const NATIONAL_TILE_ID = [
  'pasta1', 'pasta2', 'pasta3', 'pasta4',
  'dippingSauce1', 'dippingSauce2', 'dippingSauce3', 'dippingSauce4', 'dippingSauce5', 'dippingSauce6',
  'dessert1', 'dessert2', 'dessert3', 'dessert4',
  'sides1', 'sides2', 'sides3',
  'melt1', 'melt2', 'melt3', 'melt4',
  'partyofone1', 'partyofone2', 'partyofone3', 'partyofone4', 'partyofone5', 'partyofone6'
];

export {
  NATIONAL_TILE_ID
};
